import { render, staticRenderFns } from "./MenusListEdit.vue?vue&type=template&id=5c05d610"
import script from "./MenusListEdit.vue?vue&type=script&lang=js"
export * from "./MenusListEdit.vue?vue&type=script&lang=js"
import style0 from "./MenusListEdit.vue?vue&type=style&index=0&id=5c05d610&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports